module.exports = __webpack_public_path__ + "static/media/g.145bf67b.svg";